// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".routePage_root__3nFkO {\n  min-height: calc(100vh - 60px);\n  overflow: hidden;\n  background: #fafafa;\n  display: flex;\n  justify-content: center;\n  width: 100%; }\n  .routePage_root__3nFkO .routePage_content__2rFJ0 {\n    width: calc(100% - 14px);\n    min-width: 0;\n    margin: 0 auto;\n    display: flex;\n    overflow-y: auto; }\n\n.routePage_tabsContainer__38HXa {\n  display: flex;\n  flex-direction: column;\n  width: 100px; }\n", ""]);
// Exports
exports.locals = {
	"root": "routePage_root__3nFkO",
	"content": "routePage_content__2rFJ0",
	"tabsContainer": "routePage_tabsContainer__38HXa"
};
module.exports = exports;
